// "Upload stands alone" (flag REACT_APP_UPLOAD_PENDING_ENABLED, design 14/9
// §4/§5.6) - the pure mapping of the API's deterministic rejection codes
// (LogoDto.uploadFailedReason) to the user-facing texts, and the rule for
// when the rejected FILE may be offered again. No flag reads here: the call
// sites branch on the flag-gated predicates.

// The codes the API's worker writes (UploadPendingPolicy.ClassifyUpload).
export const UPLOAD_REJECT_SIZE_TOO_BIG = "SizeTooBig";
export const UPLOAD_REJECT_TOO_MANY_ARTBOARDS = "TooManyArtboards";
export const UPLOAD_REJECT_NO_SERIAL = "NoSerial";

/**
 * The i18n key of the explanation shown for a rejection code. Unknown codes
 * ("NoOriginal", "Rejected", anything newer than this build) get the
 * generic text, which carries the supplier's own message ({{message}}) -
 * or, when the API sent no message at all, a plain sentence without the
 * dangling colon the generic template would leave (skeptic round 1).
 */
export function uploadRejectedTextKey(
  reason: string | null | undefined,
  message?: string | null
): string {
  switch (reason) {
    case UPLOAD_REJECT_SIZE_TOO_BIG:
      return "upload_rejected_size_too_big";
    case UPLOAD_REJECT_TOO_MANY_ARTBOARDS:
      return "upload_rejected_too_many_artboards";
    case UPLOAD_REJECT_NO_SERIAL:
      return "upload_rejected_no_serial";
    default:
      return message && message.trim()
        ? "upload_rejected_generic"
        : "upload_rejected_unknown";
  }
}

/**
 * Whether "Upload another file" may pre-fill the New logo dialog with the
 * file that was just rejected: only when the FILE is not the problem. A
 * file the supplier found too large or with too many artboards must be
 * replaced by another one; a read failure (no serial) or an unclassified
 * rejection is worth one more try with the same file.
 */
export function canPrefillRejectedFile(reason: string | null | undefined): boolean {
  return (
    reason !== UPLOAD_REJECT_SIZE_TOO_BIG &&
    reason !== UPLOAD_REJECT_TOO_MANY_ARTBOARDS
  );
}
